import { J2Multiply } from '@e3dc-react/icons'
import { SxProps, Theme } from '@mui/material'
import React from 'react'
import ActionMenuButton from 'src/Elements/Buttons/ActionMenuButton'
import { BannerKey, useActionButton } from 'src/Libs/banners'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  button: {
    color: 'inherit',
  },
}))

interface Props {
  bannerKey: BannerKey
  onRemoveSuccessMessageKey?: string
  sxCloseIcon?: SxProps<Theme>
}

/**
 * This component is a button which opens a menu to remove a banner (temporarily or permanently).
 */
const CloseMenuButton: React.FC<Props> = ({ bannerKey, onRemoveSuccessMessageKey, sxCloseIcon }) => {
  const { classes } = useStyles()
  const { actions, anchorEl, closeMenu, handleClick } = useActionButton(bannerKey, onRemoveSuccessMessageKey)

  return (
    <ActionMenuButton
      icon={<J2Multiply sx={sxCloseIcon} />}
      actions={actions}
      anchorEl={anchorEl}
      closeMenu={closeMenu}
      handleClick={handleClick}
      containerStyle={classes.button}
    />
  )
}

export default CloseMenuButton
